import script from "./FootScan.vue?vue&type=script&setup=true&lang=js"
export * from "./FootScan.vue?vue&type=script&setup=true&lang=js"

import "./FootScan.vue?vue&type=style&index=0&id=68af2340&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68af2340"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QSpinnerHourglass,QMarkupTable,QBtn,QList,QSeparator,QItem,QItemSection,QItemLabel});
